import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import ApiConstants from '../../constants/ApiConstants';
import xhr from '../../utils/api/xhr';

export interface NotificationType {
  id: string;
  short_title: string;
  title: string;
}

export interface NotificationSetting {
  id: string;
  notification_type: NotificationType;
  active: boolean;
}

interface NotificationSettingsResponse {
  notification_settings: NotificationSetting[];
}

interface UpdateNotificationSettingsResponse {
  notification_settings: NotificationSetting[];
  message: string;
}

export interface EmailSetting {
  dbid: string | null;
  isChecked: boolean;
  id: string;
  label: string;
}

export const notificationSettingsKeys = {
  all: ['notificationSettings'] as const,
};

async function fetchNotificationSettings(): Promise<NotificationSettingsResponse> {
  return xhr(ApiConstants.Base + 'settings/notifications');
}

async function updateNotificationSettings(
  newSettings: EmailSetting[]
): Promise<UpdateNotificationSettingsResponse> {
  return xhr(ApiConstants.Base + 'settings/notifications', {
    method: 'put',
    body: JSON.stringify({
      new_settings: newSettings,
    }),
  });
}

export function useNotificationSettingsQuery() {
  return useQuery({
    queryKey: notificationSettingsKeys.all,
    queryFn: fetchNotificationSettings,
    select: (data) => data.notification_settings,
  });
}

export function useUpdateNotificationSettingsMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateNotificationSettings,
    onSuccess: (data) => {
      // Update the cache with new notification settings
      queryClient.setQueryData(notificationSettingsKeys.all, {
        notification_settings: data.notification_settings,
      });
    },
  });
}
